import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ENUM_PERMISSIONS } from '../../../enums/permission.enum';
import { PermissionMessageService } from '../../../services/permission-message.service';

/**
 * Page « accès refusé » : l'utilisateur reste sur la page (pas de redirection
 * automatique) et choisit lui-même de revenir en arrière ou d'aller à l'accueil.
 * Si le PermissionGuard a transmis la permission manquante (navigation state),
 * elle est affichée pour que l'utilisateur sache quel droit demander.
 */
@Component({
  selector: 'vex-unauthorized',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
})
export class ForbiddenComponent {
  readonly accessDeniedMessage = PermissionMessageService.ACCESS_DENIED_MESSAGE;
  missingPermissionMessage = '';

  constructor(
    private router: Router,
    private location: Location,
    permissionMessageService: PermissionMessageService,
  ) {
    // getCurrentNavigation n'est disponible que pendant la navigation ; history.state
    // prend le relais si le composant est construit après (rafraîchissement inclus).
    const permission: ENUM_PERMISSIONS | ENUM_PERMISSIONS[] | undefined =
      this.router.getCurrentNavigation()?.extras?.state?.permission ?? history.state?.permission;

    if (permission) {
      this.missingPermissionMessage = permissionMessageService.buildMissingPermissionMessage(permission);
    }
  }

  goBack(): void {
    this.location.back();
  }

  redirectToHome(): void {
    this.router.navigate(['/']).then();
  }
}
